module.exports = __webpack_public_path__ + "5c114213/img/comment-question-icon.7dd26e04.svg";